<template>
<div
  id="inbox"
  class="page page-on-center close-picker"
  data-page="inbox-page" @ptr:refresh="refreshUBODetails(false)">
  <div class="page-content infinite-scroll"
    style="z-index:9">
    <div class="layoutTop"></div>
    <div class="listPage" style="margin-left:5%;width:90%;">
      <back-button></back-button>

      <div class="pilotageTabButtonContainer pilotageTabButtonContainerRegister">
        <f7-grid>
          <f7-col class="pilotageTabController">
            <f7-link class="pilotageLink upperLeftRadius upperRightRadius tabActive"
              tab-link=".documentsTab">
              <span>
                Client : {{ currentSupplier.SocialReason }} - Identifiant : {{ currentSupplier.Siren }}
              </span>
            </f7-link>
          </f7-col>
        </f7-grid>
      </div>

      <spinner v-if="activateSpinner"></spinner>
      <f7-tabs v-else>
        <f7-tab class="documentsTab" no-gutter active>
          <spinner v-if="activateSpinner"></spinner>
          <b-container fluid v-else>
            <b-row>
              <b-col sm="3" v-for="document in documentsList"
                :key="document.IdDocument"
                v-if="document.Type !== 'PROOF_OF_ADDRESS'"
                class="documentBlocInfo">
                <document-bloc-info
                  :document="document"
                  :seller="currentSupplier"
                  :shareholder="false">
                </document-bloc-info>
              </b-col>
            </b-row>

            <b-row class="justify-content-start">
              <b-col md="3" offset-md="9">
                <f7-button v-if="currentSupplier.Status !== '31'"
                  class="button-action milkyBlockBlack"
                  @click="updateFolderStatus('31')">
                  <f7-icon fa="check"></f7-icon>
                  {{ $t('suppliers.close_doc_group') }}
                </f7-button>
                <span v-if="currentSupplier.Status === '31'"
                  style="float: right;margin-top: 20px;font-size: 20px;color: green;">
                  Compte Client Vérifié
                  <f7-icon fa="check" class="greenIcon"></f7-icon>
                </span>
                <!-- <button round v-if="currentSupplier.Status === '31'"
                  class="button-action milkyBlockBlack"
                  @click="getExchangeGroupDocument(currentSupplier.GroupDocumentId)">
                  <i class="icon fa fa-check"></i>
                  {{ 'Télécharger le rapport' }}
                </button> -->
              </b-col>
            </b-row>
          </b-container>
        </f7-tab>
      </f7-tabs>
    </div>
  </div>
</div>
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import Spinner from '@/components/common/spinner.vue'

import DocumentBlocInfo from '@/pages/requests/detailPages/supplierDetailPages/DocumentBlocInfo.vue'

import legalStatusList from '../../creationPages/data/legalstatus.json'

import {errorMessageAlert} from '@/helpers/alert'
import { statusIcon, statusLabel } from '@/helpers/labels'

export default {
  name: 'SupplierDocForm',
  components: {
    'back-button': backButton,
    'document-bloc-info': DocumentBlocInfo,
    'spinner': Spinner
  },
  data () {
    return {
      activateSpinner: true,
      availableShareholderNumber: ['0', '1', '2', '3', '4'],
      currentSupplier: {},
      currentTab: 'Documents',
      detailsDone: false,
      documentsList: [],
      legalStatusList: legalStatusList,
      numberOfShareholder: '0',
      openedShareholderAccordion: false,
      serviceId: this.$engine.user.currentService.id.toString(),
      shareholders: [],
      showableSupplierData: ['Name', 'Status', 'Bic', 'Email', 'SellerIdentifier',
        'Siren', 'SocialReason', 'LegalForm', 'StreetName', 'TownName'],
      updatedShareholders: true
    }
  },
  created () {
    this.currentSupplier = this.$engine.services.suppliers.selectedSupplier
    this.getFolderDetails()
  },
  computed: {
    oneShareholderIsLegalRepresentative () {
      let oneSHisRepresentative = false
      this.shareholders.map(holder => {
        if (holder.IsLegalRepresentative) {
          oneSHisRepresentative = true
        }
      })
      return oneSHisRepresentative
    }
  },
  methods: {
    addShareholder () {
      this.numberOfShareholder = (parseInt(this.numberOfShareholder) + 1).toString()
      this.shareholders.push({
        IsLegalRepresentative: 0,
        OrderNumber: this.numberOfShareholder,
        PercentageDetention: '25',
        FirstName: '',
        LastName: '',
        Source: 'Manuel',
        Documents: [{
          Type: 'IDCARD',
          Status: 0,
          Serialize: {}
        }, {
          Type: 'PROOF_OF_ADDRESS',
          Status: 0,
          Serialize: {}
        }]
      })
    },
    applyDocumentsFilter (filterConditions) {
      if (filterConditions.uboStatus) {
        filterConditions.uboStatus = JSON.stringify(filterConditions.uboStatus)
      }
      this.detailsDone = false
      this.activateSpinner = true
      this.getSupplierInfo()
      this.getFolderDetails(filterConditions)
    },
    callUBOinstitutionalSource (e) {
      e.stopPropagation()
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      let params = {
        Siren: this.currentSupplier.Siren,
        RepeatOnlyPP: '1',
        SaveDatabase: '1',
        IdExchangeGroup: this.currentSupplier.IdGroupDocument
      }
      let that = this
      this.$engine.services.suppliers.getUBOFromInstitutionalSource(params)
      .then(response => {
        if (response.status === 200) {
          this.$f7.hidePreloader()
          if (response.data.Beneficial != null) {
            // that.numberOfShareholder = response.data.Beneficial.length.toString()
            // that.shareholders = []
            // for (let i = 0; i < response.data.Beneficial.length; i++) {
            //   that.shareholders.push({
            //     IsLegalRepresentative: 0,
            //     OrderNumber: i + 1,
            //     FirstName: response.data.Beneficial[i].FirstName,
            //     LastName: response.data.Beneficial[i].LastName,
            //     FullName: response.data.Beneficial[i].FirstName + ' ' + response.data.Beneficial[i].LastName,
            //     PercentageDetention: response.data.Beneficial[i].PercentageDetention,
            //     Documents: [{
            //       Type: 'IDCARD',
            //       Status: 0
            //     }, {
            //       Type: 'PROOF_OF_ADDRESS',
            //       Status: 0
            //     }]
            //   })
            // }
            this.getFolderDetails({}, true)
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    changeCurrentTab (newTab) {
      if (this.currentTab !== newTab) {
        this.currentTab = newTab
      }
    },
    extractCSV (docList) {
      // to do asap
    },
    getExchangeGroupDocument (groupId) {
      let downloadLink = document.createElement('a')
      let that = this
      downloadLink.download = 'rapportKYC.pdf'
      this.$engine.services.suppliers.getBusinessFolder({
        groupIdFonctionnal: groupId
      })
      .then(resp => {
        if (resp.status === 200) {
          downloadLink.href = resp.data.document
          downloadLink.click()
        }
      })
      .catch(error => {
        this.$f7.hidePreloader()
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getFolderDetails (filterConditions = {}, loadingUBOafterSourceCalled = false) {
      let that = this
      that.updatedShareholders = false
      this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      this.$engine.services.suppliers.getDocuments(
        this.currentSupplier.IdSeller,
        filterConditions
      )
      .then(resp => {
        this.currentSupplier = resp.data.Sellers[0]
        if (!loadingUBOafterSourceCalled) {
          that.documentsList = resp.data.Sellers[0].Documents
        }
        if (resp.data.Sellers[0].UBO != null) {
          that.numberOfShareholder = resp.data.Sellers[0].UBO.length.toString()
          that.shareholders = resp.data.Sellers[0].UBO
          for (let i = 0; i < resp.data.Sellers[0].UBO.length; i++) {
            that.shareholders[i].OrderNumber = i + 1
          }
          that.updatedShareholders = true
        }
        that.activateSpinner = false
        that.detailsDone = true
        this.$f7.hidePreloader()
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getStatusIcon (keyType, status) {
      if (keyType === 'Status') {
        return statusIcon(status)
      }
      return ''
    },
    getSupplierInfo () {
      let that = this
      this.$engine.services['suppliers'].update(
        '',
        1000,
        1,
        this.$engine.services['suppliers'].filter.getConditionObject()
      ).then(resp => {
        let suppliers = resp.data.suppliers
        for (var i = 0; i < suppliers.length; i++) {
          if (suppliers[i].idgroup === that.$engine.services.suppliers.currentSendbox.idgroup) {
            that.$engine.services.suppliers.currentSendbox = suppliers[i]
            that.currentSupplier = that.$engine.services.suppliers.currentSendbox
            break
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    refreshUBODetails (noAttach = false, index = 1) {
      this.detailsDone = false
      this.activateSpinner = true
      this.getSupplierInfo()
      this.getFolderDetails()
    },
    removeShareholder (shareholder) {
      if (shareholder.IdUBO !== undefined) {
        let that = this
        that.$engine.services.suppliers.deleteUBO({
          IdUBO: shareholder.IdUBO
        })
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$i18n.t('success.UBO_deleted_success'),
              text: '<i class="icon fa fa-check"></i>'
            })
            this.shareholders.splice(shareholder.OrderNumber - 1, 1)
            for (let i = shareholder.OrderNumber - 1; i < this.shareholders.length; i++) {
              this.shareholders[i].OrderNumber -= 1
            }
            this.numberOfShareholder = (parseInt(this.numberOfShareholder) - 1).toString()
            setTimeout(function () {
              that.$f7.closeModal()
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        // to do : show confirmation alert
        this.shareholders.splice(shareholder.OrderNumber - 1, 1)
        for (let i = shareholder.OrderNumber - 1; i < this.shareholders.length; i++) {
          this.shareholders[i].OrderNumber -= 1
        }
        this.numberOfShareholder = (parseInt(this.numberOfShareholder) - 1).toString()
      }
    },
    showSellerDetailValue (keyType, value) {
      if (keyType === 'Status') {
        return statusLabel(this.$i18n, 'Provider_' + value)
      }
      if (keyType === 'LegalForm') {
        var foundLabel = ''
        this.legalStatusList['FR'].map(legalStatus => {
          if (value === legalStatus.code) {
            foundLabel = legalStatus.label
          }
        })
        return foundLabel
      }
      return value
    },
    updateFolderStatus (newFolderStatus) {
      // alert('shareholders')
      console.log(this.currentSupplier)
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      that.$engine.services.businessDocuments.updateFolderStatus({
        groupId: this.currentSupplier.IdGroupDocument,
        status: newFolderStatus
      }).then(response => {
        this.$f7.hidePreloader()
        if (response.status === 200) {
          that.$f7.modal({
            title: this.$t('businessDocuments.updated_folder'),
            text: '<span class="preloader"></span>'
          })
          that.currentSupplier.Status = newFolderStatus
          setTimeout(function () {
            that.$f7.closeModal()
          }, 1000)
        }
      }).catch(error => {
        this.$f7.hidePreloader()
        errorMessageAlert(error, that)
      })
    },
    updateNumberOfShareholder (newNumber, e) {
      if (this.openedShareholderAccordion) {
        e.stopPropagation()
      }

      // Adding new shareholders to the current list
      // if (parseInt(newNumber) > parseInt(this.numberOfShareholder)) {
      //   for (let i = parseInt(this.numberOfShareholder) + 1; i <= parseInt(newNumber); i++) {
      //     this.shareholders.push({
      //       IsLegalRepresentative: 0,
      //       OrderNumber: i,
      //       PercentageDetention: '25',
      //       FirstName: '',
      //       LastName: '',
      //       Source: 'Manuel',
      //       Documents: [{
      //         Type: 'IDCARD',
      //         Status: 0
      //       }, {
      //         Type: 'PROOF_OF_ADDRESS',
      //         Status: 0
      //       }]
      //     })
      //   }
      // } else if (parseInt(newNumber) < parseInt(this.numberOfShareholder)) {
      //   // If the new number is lower than previous number, then popping until the newnumber is reached
      //   for (let i = parseInt(this.numberOfShareholder); i > parseInt(newNumber); i--) {
      //     this.shareholders.pop()
      //   }
      // }
      // this.numberOfShareholder = newNumber
    }
  }
}
</script>
<style scoped>
.documentBlocInfo {
  border: 1px solid grey;
  overflow: auto;
}
.documentBlocInfo + .documentBlocInfo {
  border-left: 0;
}
</style>
